export const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
export const APP_KEY = ''; // www机器人的appkey  QaYFdGqK
// export const LY_APP_KEY = 'zTgCaWDf'; // 鹿用机器人的appkey



// WEBPACK FOOTER //
// ./src/constants/static.js